export const WIZARD_DEFINITION = {
  identifier: 'onlineterminal-wizard-configuration',
  defaultWizardFlowStepIdentifier: 'onlineterminal-wizard-configuration',
  wizardFlowMetadata: [
    {
      flowIdentifier: 'execute-instruction',
      flowDefinition: {
        title: 'Unterweisung durchführen',
        key: 'visit-instruction',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-masterdata.title',
            key: 'visitor-registration-masterdata',
            controller: 'visitor-registration-masterdata-controller',
            contentIdentifier: 'dashboard-visitor-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-instructions.title',
            key: 'instruction-test',
            controller: 'instruction-test-controller',
            contentIdentifier: 'WIDGET@instructionTestWidget',
            dashboardConfiguration: {
              instructionConfigurationUrls: ['/assets/default/instruction.json']
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-masterdata.title',
            key: 'additionalVisitorWidget',
            controller: 'visitor-instructions-finished-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-summary.title',
            key: 'visitor-registration-summary',
            controller: 'visitor-registration-qrcode-controller',
            contentIdentifier: 'WIDGET@visitorRegistrationQRCodeWidget'
          }
        ]
      }
    },
    {
      flowIdentifier: 'add-additional-visitor',
      flowDefinition: {
        title: 'Unterweisung durchführen',
        key: 'visit-instruction',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-masterdata.title',
            key: 'additionalVisitorWidget',
            controller: 'visitor-additional-visitor-controller',
            contentIdentifier: 'WIDGET@additionalVisitorWidget'
          }
        ]
      }
    },
    {
      flowIdentifier: 'print-registration-qrcode',
      flowDefinition: {
        title: 'QRCode drucken',
        key: 'print-registration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-summary.title',
            key: 'visitor-registration-summary',
            controller: 'visitor-registration-qrcode-controller',
            contentIdentifier: 'WIDGET@visitorRegistrationQRCodeWidget',
            dashboardConfiguration: {
              targetProcessFlowOnFinish: 'onlineterminal-wizard-configuration'
            }
          }
        ]
      }
    },
    {
      flowIdentifier: 'onlineterminal-wizard-configuration',
      flowDefinition: {
        title: 'Unterweisung',
        key: 'onlineterminal-wizard-configuration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: null,
            key: 'load-terminal-configuration',
            controller: 'terminal-configuration-controller',
            contentIdentifier: null,
            dashboardConfiguration: {
              terminalIdentifier: 'onlineterminal'
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.language-selection.title',
            key: 'language-selection',
            controller: 'language-selection-controller',
            contentIdentifier: 'dashboard-language-selection'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.title',
            key: 'visitor-registration-with-code',
            controller: 'visitor-registration-with-code-controller',
            contentIdentifier: 'WIDGET@registrationWithCodeQRCodeCombinedWidget',
            dashboardConfiguration: {
              showCreateNewRegistrationButton: false,
              qrCodeScanEnabled: false,
              nextProcessStepRegistrationCode: 'visitor-onlineterminal-calculate-process-options'
            }
          },
          {
            title: null,
            key: 'visitor-onlineterminal-calculate-process-options',
            controller: 'visitor-onlineterminal-calculate-process-options-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              flowMapping: {
                inviteAdditionalVisitor: 'add-additional-visitor',
                printRegistrationQRCode: 'print-registration-qrcode',
                startInstructions: 'execute-instruction'
              }
            }
          }
        ]
      }
    }
  ]
};
